import { z } from 'zod';
import { ZBaseIntegrationConfig } from './base.js';
export const FACEBOOK_INTEGRATION_NAME = 'facebook';
export const ZFacebookCredentials = z.object({
    /** Meta Pixel ID — numeric string, 14–16 digits. */
    pixelId: z
        .string()
        .regex(/^\d{14,16}$/, 'Pixel ID must be 14–16 digits')
        .optional(),
    /**
     * System User long-lived access token. Meta tokens start with `EAA` and are
     * typically ~190 chars. We enforce the prefix + a heuristic min length to catch
     * common copy-paste mistakes (truncation, pasting only the prefix, etc.).
     */
    accessToken: z
        .string()
        .min(20)
        .startsWith('EAA', 'Must be a Meta System User token (starts with EAA)')
        .optional(),
});
export const ZFacebookSettings = z.object({
    /** Default true — push Purchase to fbq with eventID for CAPI dedup. */
    enableClientSide: z.boolean().optional(),
    /** Default true — send Purchase server-side via Conversions API. */
    enableServerSide: z.boolean().optional(),
});
export const ZFacebookIntegrationConfig = ZBaseIntegrationConfig.extend(z.object({
    integrationName: z.literal(FACEBOOK_INTEGRATION_NAME),
    category: z.literal('analytics'),
    credentials: ZFacebookCredentials.optional(),
    settings: ZFacebookSettings.optional(),
}).shape);
//# sourceMappingURL=facebook.js.map